// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"4c48bb8c","239":"926bd5ef","455":"a878dfa2","977":"03e1de1f"}[chunkId] + ".chunk.js";
};